(() => {
  'use strict';
  if (customElements.get('co-cart-reservation-timer')) return;
  const key = 'co-kit-offer-deadline-6m-v2';
  let memoryDeadline;
  const clearDeadline = () => {
    if (document.documentElement.hasAttribute('data-co-gifts-cart')) return;
    memoryDeadline = undefined;
    try { localStorage.removeItem(key); } catch (_) {}
  };
  if (!document.querySelector('co-cart-reservation-timer')) clearDeadline();
  new MutationObserver(clearDeadline).observe(document.documentElement, {
    attributes: true, attributeFilter: ['data-co-gifts-cart']
  });
  customElements.define('co-cart-reservation-timer', class extends HTMLElement {
    connectedCallback() {
      const duration = Math.max(1, Number(this.dataset.minutes) || 6) * 60000;
      let saved;
      try { saved = Number(localStorage.getItem(key)); } catch (_) {}
      this.deadline = saved > 0 ? saved : (memoryDeadline || Date.now() + duration);
      memoryDeadline = this.deadline;
      try { localStorage.setItem(key, String(this.deadline)); } catch (_) {}
      this.clock = this.querySelector('[data-co-countdown]');
      this.label = this.querySelector('[data-co-timer-label]');
      this.interval = setInterval(() => this.tick(), 1000);
      this.tick();
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (!this.clock || !this.label) return;
      this.clock.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      // This timer is presentation only. Never remove items, change a price,
      // restart the clock on a drawer refresh, or claim a real stock hold.
      if (seconds === 0) {
        this.hidden = false;
        this.clock.hidden = true;
        this.clock.style.display = 'none';
        this.label.textContent = this.dataset.expiredLabel || 'Offer timer ended';
        clearInterval(this.interval);
      }
    }
  });
})();
